var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCp2StickerSelfDestroyingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#3c3c46;opacity:0.15;}.b,.c,.d,.e{fill-rule:evenodd;}.c{fill:#89d9fb;}.c,.d,.e{stroke:#3c3c46;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.d{fill:#ffefe0;}.e{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-sticker-self-destroying-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M73,50l1.84,11.1-2.21,6.72,3.58,6.84-2.84,4.21,3.26,9.46-2.3,4.32h47.38a5.56,5.56,0,0,0,5.54-5.54V55.57A5.56,5.56,0,0,0,121.68,50Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M24.32,53.33H66.86l1.84,11.1-2.21,6.72L70.07,78l-2.84,4.21,3.26,9.46L68.19,96H24.32a5.56,5.56,0,0,1-5.54-5.54V58.87A5.56,5.56,0,0,1,24.32,53.33Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M67,44l1.84,11.1-2.21,6.72,3.58,6.84-2.84,4.21,3.26,9.46-2.3,4.32h47.38a5.56,5.56,0,0,0,5.54-5.54V69.62L95.64,44Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M18.32,47.33H60.86l1.84,11.1-2.21,6.72L64.07,72l-2.84,4.21,3.26,9.46L62.19,90H18.32a5.56,5.56,0,0,1-5.54-5.54V52.87A5.56,5.56,0,0,1,18.32,47.33Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M95.64,44h20a5.56,5.56,0,0,1,5.54,5.54v20Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M121.22,69.62l-20,6.32c-3,1-5.54-.75-5.54-3.8v-20Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M121.22,69.62h-20a5.56,5.56,0,0,1-5.54-5.54V44Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCp2StickerSelfDestroyingIcon);
export default __webpack_public_path__ + "static/media/CP2-sticker-self-destroying-icon.b16365c9410adb74cd9fff39c3c83cc9.svg";
export { ForwardRef as ReactComponent };